"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpDataInsight = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var DpDataInsight_styled_1 = require("./DpDataInsight.styled");
var styled_components_1 = require("styled-components");
var api_1 = require("../../../api");
var DpModal_1 = __importDefault(require("../Modal/DpModal"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
var AtomicAlertManagerContext_1 = require("../AtomicAlert/AtomicAlertManagerContext");
var DpProficientBandLegend_1 = __importDefault(require("../ProficientBandLegend/DpProficientBandLegend"));
var Spinner_1 = require("../Spinner/Spinner");
var DpNavigationTabs_1 = __importDefault(require("../NavigationTabs/DpNavigationTabs"));
var DpCollapse_1 = __importDefault(require("../Collapse/DpCollapse"));
var tableHeader = [
    { id: 'all', label: 'All' },
    { id: 'students', label: 'Student' },
    { id: 'standard', label: 'Standard' },
    { id: 'assessment', label: 'Assessment' },
];
var themeBands = (_a = {},
    _a[api_1.Bands.NotProficient] = 'notYet',
    _a[api_1.Bands.PartiallyProficient] = 'partial',
    _a[api_1.Bands.HighlyProficient] = 'highlyProficient',
    _a[api_1.Bands.Proficient] = 'proficient',
    _a);
var StudentDetailsAndReopenCount = /** @class */ (function (_super) {
    __extends(StudentDetailsAndReopenCount, _super);
    function StudentDetailsAndReopenCount(data) {
        if (data === void 0) { data = {}; }
        var _this = _super.call(this, data) || this;
        _this.assessmentAssignedCount = data.assessmentAssignedCount;
        _this.reopenCount = data.reopenCount;
        return _this;
    }
    return StudentDetailsAndReopenCount;
}(api_1.User));
var StudentsDataModal = function (_a) {
    var title = _a.title, listTitle = _a.listTitle, show = _a.show, onHide = _a.onHide, studentsDetails = _a.studentsDetails;
    return ((0, jsx_runtime_1.jsxs)(DpDataInsight_styled_1.StyledListModal, { show: show, onHide: onHide, size: "md", "aria-labelledby": "unassigned-students-modal", children: [(0, jsx_runtime_1.jsx)(DpModal_1.default.Header, { children: (0, jsx_runtime_1.jsx)("span", { id: "unassigned-students-modal", children: title }) }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Body, { children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("th", { children: listTitle }) }) }), (0, jsx_runtime_1.jsx)("tbody", { children: studentsDetails.map(function (_a) {
                                var lastNameFirstName = _a.lastNameFirstName, id = _a.id;
                                return ((0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", { children: lastNameFirstName }) }, id));
                            }) })] }) }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Footer, {})] }));
};
var BelowPerformingStudentsModal = function (_a) {
    var _b = _a.show, show = _b === void 0 ? true : _b, closeHandler = _a.closeHandler, performanceData = _a.performanceData;
    var studentsPerformance = performanceData.studentsPerformance;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return ((0, jsx_runtime_1.jsxs)(DpDataInsight_styled_1.StyledListModal, { show: show, onHide: closeHandler, size: "md", "aria-labelledby": "below-performing-students-modal", children: [(0, jsx_runtime_1.jsx)(DpModal_1.default.Header, { children: (0, jsx_runtime_1.jsx)("span", { id: "below-performing-students-modal", children: t('dataInsight.belowPerformingStudents.title') }) }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Body, { children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: t('dataInsight.studentName') }), (0, jsx_runtime_1.jsx)("th", { children: t('dataInsight.score') })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: studentsPerformance.map(function (student) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: student.name }), (0, jsx_runtime_1.jsxs)("td", { children: [student.overallPercentage, "%"] })] }, student.id)); }) })] }) }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Footer, {})] }));
};
var ReOpenAssessmentStudentsModal = function (_a) {
    var title = _a.title, show = _a.show, onHide = _a.onHide, studentsDetails = _a.studentsDetails;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return ((0, jsx_runtime_1.jsxs)(DpDataInsight_styled_1.StyledListModal, { show: show, onHide: onHide, size: "md", "aria-labelledby": "reopen-assessments-count-students-modal", children: [(0, jsx_runtime_1.jsx)(DpModal_1.default.Header, { children: title }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Body, { children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: t('dataInsight.assessmentTemplates.studentName') }), (0, jsx_runtime_1.jsx)("th", { children: t('dataInsight.assessmentTemplates.noOfAssessments') }), (0, jsx_runtime_1.jsx)("th", { children: t('dataInsight.assessmentTemplates.noOfReopened') })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: studentsDetails.map(function (_a) {
                                var id = _a.id, lastNameFirstName = _a.lastNameFirstName, assessmentAssignedCount = _a.assessmentAssignedCount, reopenCount = _a.reopenCount;
                                return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: lastNameFirstName }), (0, jsx_runtime_1.jsx)("td", { children: assessmentAssignedCount }), (0, jsx_runtime_1.jsx)("td", { children: reopenCount })] }, id));
                            }) })] }) }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Footer, {})] }));
};
var StandardPerformancesDetailsBelowClassAverageModal = function (_a) {
    var title = _a.title, standardTitle = _a.standardTitle, scoreTitle = _a.scoreTitle, show = _a.show, onHide = _a.onHide, standardsWithPercentage = _a.standardsWithPercentage;
    return ((0, jsx_runtime_1.jsxs)(DpDataInsight_styled_1.StyledListModal, { show: show, onHide: onHide, size: "md", "aria-labelledby": "standards-score-modal", children: [(0, jsx_runtime_1.jsx)(DpModal_1.default.Header, { children: (0, jsx_runtime_1.jsx)("span", { id: "standards-score-modal", children: title }) }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Body, { children: (0, jsx_runtime_1.jsxs)("table", { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("th", { children: standardTitle }), (0, jsx_runtime_1.jsx)("th", { children: scoreTitle })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: standardsWithPercentage.map(function (standardInfo) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: standardInfo.standard }), (0, jsx_runtime_1.jsxs)("td", { children: [standardInfo.percentage, "%"] })] }, standardInfo.standard)); }) })] }) }), (0, jsx_runtime_1.jsx)(DpModal_1.default.Footer, {})] }));
};
var rowContainer = function (_a) {
    var iconName = _a.iconName, children = _a.children;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { name: iconName, "aria-label": iconName }), (0, jsx_runtime_1.jsx)("div", { children: children })] }));
};
var getPerformanceInfoOfAssessments = function (assessmentsInfo) {
    var updatedData = assessmentsInfo.reduce(function (assessmentsInfo, assessment) {
        assessmentsInfo.set(assessment.id, assessment);
        return assessmentsInfo;
    }, new Map());
    return updatedData;
};
var sortStudentsListData = function (studentsListData) {
    return studentsListData.sort(function (student1, student2) {
        return student1.lastNameFirstName.localeCompare(student2.lastNameFirstName);
    });
};
var allInsightsKeys = [
    'areAllStandardsScoreEqual',
    'areAllItemsPerformanceEqual',
    'highestPerformingStandards',
    'highestPerformingItems',
    'HighestPerformingAssessment',
    'lowestPerformingStandards',
    'lowestPerformingItems',
    'lowestPerformingAssessment',
    'maxScoreStudents',
    'minScoreStudents',
    'reOpenCount',
    'standardsPerformingBelowClassAverage',
    'studentsPerformingBelowAverage',
    'allStudentsPerformingEqually',
    'bandsDistribution',
    'highestSkippedQuestions',
];
var themeBandsKeysi18 = function (key, count) { return (count > 1 ? "".concat(key, "Students") : "".concat(key, "Student")); };
var defaultStandardInsights = {
    highestPerformingStandards: [],
    lowestPerformingStandards: [],
    areAllStandardsScoreEqual: false,
};
var defaultStudentsInsights = {
    overallPercentage: null,
    studentsPerformance: [],
    isAllStudentsPerformingEqually: false,
    highestSkippedQuestions: [],
    maxorminScoreStudentData: null,
    bandsDistribution: null,
};
var DpDataInsight = function (_a) {
    var activeAssessment = _a.activeAssessment, classPerformance = _a.classPerformance, formattedData = _a.formattedData, itemStandards = _a.itemStandards, openQuestionModal = _a.openQuestionModal, students = _a.students, openStandardsModal = _a.openStandardsModal, assigneesPerformance = _a.assigneesPerformance;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    var _b = (0, react_1.useContext)(api_1.ServiceContext), performanceBandService = _b.performanceBandService, analyticsService = _b.analyticsService, assigneeUsageService = _b.assigneeUsageService, summaryService = _b.summaryService;
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    var _c = (0, react_1.useState)(''), elementId = _c[0], setElementId = _c[1];
    var _d = (0, react_1.useState)(false), isDataLoaded = _d[0], setDataLoaded = _d[1];
    var _e = (0, react_1.useState)(false), isLoadingDataInsights = _e[0], setIsLoadingDataInsights = _e[1];
    var _f = (0, react_1.useState)({
        overallPercentage: null,
        studentsPerformance: null,
        isAllStudentsPerformingEqually: false,
    }), studentsInsight = _f[0], setStudentsInsight = _f[1];
    var _g = (0, react_1.useState)([]), studentUiInsights = _g[0], setStudentUiInsights = _g[1];
    var _h = (0, react_1.useState)([]), standardUiInsights = _h[0], setStandardUiInsights = _h[1];
    var _j = (0, react_1.useState)({
        areAllItemsPerformanceEqual: false,
        highestPerformingItems: [],
        lowestPerformingItems: [],
    }), assessmentUiInsights = _j[0], setAssessmentUiInsights = _j[1];
    var _k = (0, react_1.useState)([]), unassignedStudents = _k[0], setUnassignedStudents = _k[1];
    var _l = (0, react_1.useState)({}), lowestAssessment = _l[0], setLowestAssessment = _l[1];
    var _m = (0, react_1.useState)({}), highestAssessment = _m[0], setHighestAssessment = _m[1];
    var _o = (0, react_1.useState)([]), maxScoreStudents = _o[0], setMaxScoreStudents = _o[1];
    var _p = (0, react_1.useState)([]), minScoreStudents = _p[0], setMinScoreStudents = _p[1];
    var _q = (0, react_1.useState)([]), reopenAssessmentStudents = _q[0], setReopenAssessmentStudents = _q[1];
    var _r = (0, react_1.useState)(false), showUnAssignedStudents = _r[0], setShowUnAssignedStudents = _r[1];
    var _s = (0, react_1.useState)(false), showReopenAssessmentStudents = _s[0], setShowReopenAssessmentStudents = _s[1];
    var _t = (0, react_1.useState)([]), standardsInfoBelowClassAverage = _t[0], setStandardsInfoBelowClassAverage = _t[1];
    var _u = (0, react_1.useState)(false), showStandardsWithScoreModal = _u[0], setShowStandardsWithScoreModal = _u[1];
    var _v = (0, react_1.useState)(false), showMaxScoreStudentsModal = _v[0], setShowMaxScoreStudentsModal = _v[1];
    var _w = (0, react_1.useState)(false), showMinScoreStudentsModal = _w[0], setShowMinScoreStudentsModal = _w[1];
    var toggleMaxScoreStudentsModal = (0, react_1.useCallback)(function () {
        setShowMaxScoreStudentsModal(!showMaxScoreStudentsModal);
    }, [showMaxScoreStudentsModal]);
    var toggleMinScoreStudentsModal = (0, react_1.useCallback)(function () {
        setShowMinScoreStudentsModal(!showMinScoreStudentsModal);
    }, [showMinScoreStudentsModal]);
    var _x = (0, react_1.useState)(false), showBelowPerformingStudentsModal = _x[0], toggleShowBelowPerformingStudentsModal = _x[1];
    var toggleBelowPerformingStudentsModal = (0, react_1.useCallback)(function () {
        toggleShowBelowPerformingStudentsModal(function (prevState) { return !prevState; });
    }, [toggleShowBelowPerformingStudentsModal]);
    var toggleUnAssignedStudentsModal = (0, react_1.useCallback)(function () { return setShowUnAssignedStudents(!showUnAssignedStudents); }, [showUnAssignedStudents]);
    var toggleReOpenAssessmentsStudentsModal = (0, react_1.useCallback)(function () { return setShowReopenAssessmentStudents(!showReopenAssessmentStudents); }, [showReopenAssessmentStudents]);
    var toggleStandardsWithScoreModal = (0, react_1.useCallback)(function () { return setShowStandardsWithScoreModal(!showStandardsWithScoreModal); }, [showStandardsWithScoreModal]);
    var standardToItemExternalIdMap = (0, react_1.useMemo)(function () {
        if (itemStandards) {
            var idMap_1 = itemStandards.reduce(function (map, itemStandard) {
                var _a;
                (_a = itemStandard.standardGlobalIds) === null || _a === void 0 ? void 0 : _a.forEach(function (globalId) {
                    if (!map.has(globalId)) {
                        map.set(globalId, itemStandard.externalItemId);
                    }
                });
                return map;
            }, new Map());
            idMap_1.forEach(function (value, key) {
                idMap_1.set((0, api_1.getShortCodeFromGlobalId)(key), value);
            });
            return idMap_1;
        }
        return new Map();
    }, [itemStandards]);
    var legendColors = (0, react_1.useMemo)(function () {
        var _a;
        var curriculum = activeAssessment.assessmentTemplate.curriculum;
        return _a = {},
            _a[api_1.Bands.NotProficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), 'notYet'),
            _a[api_1.Bands.Proficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), 'proficient'),
            _a[api_1.Bands.PartiallyProficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), 'partial'),
            _a[api_1.Bands.HighlyProficient] = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(curriculum), 'highlyProficient'),
            _a;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [themeContext, activeAssessment]);
    var getProficiencyAriaLabel = (0, react_1.useCallback)(function (key, student) {
        return t("dataInsight.studentTemplates.".concat(key), {
            student: student,
        });
    }, [t]);
    var fetchStandardsDataInsights = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var assessmentClass, assessmentTemplate, bands, standardCodeFromItemStandard, assigneesStandardPerformanceData, updatedAssigneeStandardPerformanceData, overallStandardsPerformanceData_1, standardsMapWithPercentage_1, standardsPerformingBelowClassAverage_1, scoresArray, minValue_1, maxValue_1, areAllStandardsScoreEqual, highestPerformingStandards_1, lowestPerformingStandards_1, standardsDataInsightInfo, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(activeAssessment && itemStandards && itemStandards.length)) return [3 /*break*/, 6];
                    assessmentClass = activeAssessment.assessmentClass, assessmentTemplate = activeAssessment.assessmentTemplate;
                    return [4 /*yield*/, performanceBandService.findByCurriculum(assessmentTemplate.curriculum)];
                case 1:
                    bands = _a.sent();
                    standardCodeFromItemStandard = (0, api_1.getStandardCodeFromItemStandard)([
                        {
                            assessmentTemplateId: assessmentTemplate.id,
                            itemStandards: itemStandards,
                        },
                    ]);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, analyticsService.getAssigneesStandardPerformanceByClassAndTemplate([assessmentClass], [assessmentTemplate], bands, (0, api_1.getDefaultHierarchyLevelByCurriculum)(assessmentTemplate.curriculum), standardCodeFromItemStandard.standards, standardCodeFromItemStandard.itemStandards)];
                case 3:
                    assigneesStandardPerformanceData = _a.sent();
                    updatedAssigneeStandardPerformanceData = assigneesStandardPerformanceData.map(function (assigneeStandardPerformanceData) {
                        return new api_1.AssigneeStandardPerformance(__assign(__assign({}, assigneeStandardPerformanceData), { standardsPerformance: assigneeStandardPerformanceData.standardsPerformance.filter(function (_a) {
                                var attempted = _a.attempted;
                                return attempted;
                            }) }));
                    });
                    return [4 /*yield*/, analyticsService.getOverallStandardPerformanceByClassAndTemplate([assessmentClass], updatedAssigneeStandardPerformanceData, bands, standardCodeFromItemStandard.standards)];
                case 4:
                    overallStandardsPerformanceData_1 = _a.sent();
                    standardsMapWithPercentage_1 = new Map(standardCodeFromItemStandard.standards.map(function (standard) { return [standard, 0]; }));
                    standardsPerformingBelowClassAverage_1 = 0;
                    if (standardsMapWithPercentage_1.size &&
                        overallStandardsPerformanceData_1.standardsPerformance.length) {
                        overallStandardsPerformanceData_1.standardsPerformance.forEach(function (standardPerformance) {
                            standardsMapWithPercentage_1.set(standardPerformance.standard, standardPerformance.percentage);
                            if ((0, api_1.formatPercentage)(standardPerformance.percentage) <
                                (0, api_1.formatPercentage)(overallStandardsPerformanceData_1.overallPercentage)) {
                                setStandardsInfoBelowClassAverage(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [
                                    {
                                        standard: (0, api_1.getShortCodeFromGlobalId)(standardPerformance.standard),
                                        percentage: (0, api_1.formatPercentage)(standardPerformance.percentage),
                                    },
                                ], false); });
                                standardsPerformingBelowClassAverage_1++;
                            }
                        });
                        scoresArray = Array.from(standardsMapWithPercentage_1.values());
                        minValue_1 = 100;
                        maxValue_1 = 0;
                        scoresArray.forEach(function (value) {
                            if (value > maxValue_1) {
                                maxValue_1 = Math.round(value);
                            }
                            if (value < minValue_1) {
                                minValue_1 = Math.round(value);
                            }
                        });
                        areAllStandardsScoreEqual = minValue_1 === maxValue_1;
                        highestPerformingStandards_1 = [];
                        lowestPerformingStandards_1 = [];
                        standardsDataInsightInfo = {
                            highestPerformingStandards: highestPerformingStandards_1,
                            lowestPerformingStandards: lowestPerformingStandards_1,
                            areAllStandardsScoreEqual: areAllStandardsScoreEqual,
                            standardsPerformingBelowClassAverage: standardsPerformingBelowClassAverage_1,
                        };
                        if (!areAllStandardsScoreEqual) {
                            standardCodeFromItemStandard.standards.forEach(function (standard) {
                                var standardsPercentageRoundedValue = Math.round(standardsMapWithPercentage_1.get(standard));
                                if (standardsPercentageRoundedValue === maxValue_1) {
                                    highestPerformingStandards_1.push((0, api_1.getShortCodeFromGlobalId)(standard));
                                }
                                if (standardsPercentageRoundedValue === minValue_1) {
                                    lowestPerformingStandards_1.push((0, api_1.getShortCodeFromGlobalId)(standard));
                                }
                            });
                        }
                        return [2 /*return*/, standardsDataInsightInfo];
                    }
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    toast({
                        alertVariant: 'error',
                        content: {
                            title: t('errorMessages.oopsErr'),
                            message: t('errorMessages.standardsData'),
                        },
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeAssessment]);
    var createStudentInsightsUI = function (_a) {
        var _b;
        var studentsPerformance = _a.studentsPerformance, isAllStudentsPerformingEqually = _a.isAllStudentsPerformingEqually, maxorminScoreStudentData = _a.maxorminScoreStudentData, bandsDistribution = _a.bandsDistribution, highestSkippedQuestions = _a.highestSkippedQuestions;
        var studentData = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (maxorminScoreStudentData.maxStudentsList.length > 0
            ? [
                {
                    insightKey: 'maxScoreStudents',
                    iconName: 'double-up',
                    children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "link", onClick: toggleMaxScoreStudentsModal, children: t("dataInsight.studentTemplates.".concat(maxorminScoreStudentData.maxStudentsList.length > 1 ? 'students' : 'student'), {
                                    students: maxorminScoreStudentData.maxStudentsList.length,
                                }) }), t("dataInsight.studentTemplates.maxScore")] })),
                },
            ]
            : []), true), (maxorminScoreStudentData.minStudentsList.length > 0
            ? [
                {
                    insightKey: 'minScoreStudents',
                    iconName: 'double-down',
                    children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "link", onClick: toggleMinScoreStudentsModal, children: t("dataInsight.studentTemplates.".concat(maxorminScoreStudentData.minStudentsList.length > 1 ? 'students' : 'student'), {
                                    students: maxorminScoreStudentData.minStudentsList.length,
                                }) }), t("dataInsight.studentTemplates.minScore")] })),
                },
            ]
            : []), true), (!isAllStudentsPerformingEqually && studentsPerformance.length === 0
            ? []
            : isAllStudentsPerformingEqually
                ? [
                    {
                        insightKey: 'allStudentsPerformingEqually',
                        iconName: 'bell-o',
                        children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dataInsight.belowPerformingStudents.allAreAveragePerforming') }),
                    },
                ]
                : [
                    {
                        insightKey: 'studentsPerformingBelowAverage',
                        iconName: 'double-down',
                        children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "link", onClick: function () { return toggleBelowPerformingStudentsModal(); }, children: "".concat(studentsPerformance === null || studentsPerformance === void 0 ? void 0 : studentsPerformance.length, " ").concat((studentsPerformance === null || studentsPerformance === void 0 ? void 0 : studentsPerformance.length) > 1
                                        ? t('dataInsight.belowPerformingStudents.students')
                                        : t('dataInsight.belowPerformingStudents.student'), " ") }, "studentsPerformingBelowAverage"), t("dataInsight.belowPerformingStudents.performingBelowClassAverageStudent".concat((studentsPerformance === null || studentsPerformance === void 0 ? void 0 : studentsPerformance.length) > 1 ? 's' : '').concat(activeAssessment.assessmentTemplate.isDiagnostic ? 'Equip' : ''))] })),
                    },
                ]), true), (((_b = bandsDistribution.distribution) === null || _b === void 0 ? void 0 : _b.length)
            ? [
                {
                    insightKey: 'bandsDistribution',
                    iconName: 'bell-o',
                    children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('dataInsight.studentTemplates.proficiency'), bandsDistribution.distribution.map(function (bandItem, bandItemIndex) { return ((0, jsx_runtime_1.jsx)(DpProficientBandLegend_1.default, { color: legendColors[bandItem.band.code], labelKey: themeBands[bandItem.band.code], count: bandItem.sample, ariaLabel: getProficiencyAriaLabel(themeBandsKeysi18(themeBands[bandItem.band.code], bandItem.sample), bandItem.sample) }, bandItem.band.code)); })] })),
                },
            ]
            : []), true), ((highestSkippedQuestions === null || highestSkippedQuestions === void 0 ? void 0 : highestSkippedQuestions.length) > 0
            ? [
                {
                    iconName: 'bell-o',
                    insightKey: 'highestSkippedQuestions',
                    children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t("dataInsight.studentTemplates.highestSkippedQuestion".concat(highestSkippedQuestions.length > 1 ? 's' : ''), {
                                skipPercentage: Math.round(highestSkippedQuestions[0].skipPercentage),
                            }), highestSkippedQuestions.map(function (item, itemIndex) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("button", { className: "link", onClick: function () { return openQuestionDetails(item.label); }, id: "question-".concat(item.label), children: [t('dataInsight.assessmentTemplates.question'), item.label] }, item.label), itemIndex !== highestSkippedQuestions.length - 1 ? ', ' : ''] })); })] })),
                },
            ]
            : []), true);
        setStudentUiInsights(studentData);
    };
    var openQuestionDetails = (0, react_1.useCallback)(function (itemLabel) {
        var currentItemData = classPerformance === null || classPerformance === void 0 ? void 0 : classPerformance.itemsPerformance.find(function (_a) {
            var item = _a.item;
            return item.label === itemLabel;
        });
        openQuestionModal(currentItemData.item);
    }, [classPerformance === null || classPerformance === void 0 ? void 0 : classPerformance.itemsPerformance, openQuestionModal]);
    var createAssessmentInsightsUI = (0, react_1.useMemo)(function () { return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (assessmentUiInsights.areAllItemsPerformanceEqual
        ? [
            {
                insightKey: 'areAllItemsPerformanceEqual',
                iconName: 'bell-o',
                children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dataInsight.assessmentTemplates.equalPerformance') }),
            },
        ]
        : assessmentUiInsights.highestPerformingItems.length === 0
            ? [
                {
                    iconName: 'bell-o',
                    insightKey: 'noItemsExist',
                    children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dataInsight.assessmentTemplates.noItemsExist') }),
                },
            ]
            : [
                {
                    iconName: 'double-up',
                    insightKey: 'highestPerformingItems',
                    children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [assessmentUiInsights.highestPerformingItems.length > 1
                                ? t('dataInsight.assessmentTemplates.highestPerformedItems')
                                : t('dataInsight.assessmentTemplates.highestPerformedItem'), assessmentUiInsights.highestPerformingItems.map(function (item, itemIndex) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("button", { className: "link", onClick: function () { return openQuestionDetails(item); }, id: "question-".concat(item), children: [t('dataInsight.assessmentTemplates.question'), item] }, item), itemIndex !== assessmentUiInsights.highestPerformingItems.length - 1
                                        ? ', '
                                        : ''] })); })] })),
                },
                {
                    iconName: 'double-down',
                    insightKey: 'lowestPerformingItems',
                    children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [assessmentUiInsights.lowestPerformingItems.length > 1
                                ? t('dataInsight.assessmentTemplates.lowestPerformedItems')
                                : t('dataInsight.assessmentTemplates.lowestPerformedItem'), assessmentUiInsights.lowestPerformingItems.map(function (item, itemIndex) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("button", { className: "link", onClick: function () { return openQuestionDetails(item); }, id: "question-".concat(item), children: [t('dataInsight.assessmentTemplates.question'), item] }, item), itemIndex !== assessmentUiInsights.lowestPerformingItems.length - 1
                                        ? ', '
                                        : ''] })); })] })),
                },
            ]), true), [
        {
            iconName: 'bell-o',
            insightKey: 'highestPerformingItems',
            children: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: unassignedStudents.length ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('dataInsight.assessmentTemplates.unAssigned.notAssignedToNStudentsPart1'), (0, jsx_runtime_1.jsx)("button", { className: "link", onClick: toggleUnAssignedStudentsModal, id: "unassigned-students", children: t("dataInsight.assessmentTemplates.unAssigned.".concat(unassignedStudents.length > 1 ? 'students' : 'student'), { studentCount: unassignedStudents.length }) }), t('dataInsight.assessmentTemplates.unAssigned.notAssignedToNStudentsPart2', {
                            className: activeAssessment.assessmentClass.name,
                        })] })) : (t('dataInsight.assessmentTemplates.unAssigned.assignedToAllStudents', {
                    className: activeAssessment.assessmentClass.name,
                })) })),
        }
    ], false), (reopenAssessmentStudents.length > 0
        ? [
            {
                iconName: 'bell-o',
                insightKey: 'reOpenCount',
                children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('dataInsight.assessmentTemplates.reOpened.reOpenedAssessmentsPart1'), (0, jsx_runtime_1.jsx)("button", { className: "link", onClick: toggleReOpenAssessmentsStudentsModal, id: "reopenCount-students", children: t("dataInsight.assessmentTemplates.reOpened.".concat(reopenAssessmentStudents.length > 1 ? 'students' : 'student'), { studentCount: reopenAssessmentStudents.length }) }), t('dataInsight.assessmentTemplates.reOpened.reOpenedAssessmentsPart2')] })),
            },
        ]
        : []), true), (lowestAssessment.exist
        ? [
            {
                iconName: 'double-down',
                insightKey: 'lowestPerformingAssessment',
                children: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: lowestAssessment.count === 0 ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dataInsight.assessmentTemplates.performedAssessment.lowestPerformedAssessment', {
                            className: activeAssessment.assessmentClass.name,
                        }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('dataInsight.assessmentTemplates.performedAssessment.lowestPerformedAssessments', {
                                assessmentCount: lowestAssessment.count,
                            }), t("dataInsight.assessmentTemplates.performedAssessment.".concat(lowestAssessment.count > 1 ? 'assessments' : 'assessment'), {
                                className: activeAssessment.assessmentClass.name,
                                assessmentCount: lowestAssessment.count,
                            })] })) })),
            },
        ]
        : []), true), (highestAssessment.exist
        ? [
            {
                iconName: 'double-up',
                insightKey: 'HighestPerformingAssessment',
                children: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: highestAssessment.count === 0 ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dataInsight.assessmentTemplates.performedAssessment.highestPerformedAssessment', {
                            className: activeAssessment.assessmentClass.name,
                        }) })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('dataInsight.assessmentTemplates.performedAssessment.highestPerformedAssessments', {
                                assessmentCount: highestAssessment.count,
                            }), t("dataInsight.assessmentTemplates.performedAssessment.".concat(highestAssessment.count > 1 ? 'assessments' : 'assessment'), {
                                className: activeAssessment.assessmentClass.name,
                                assessmentCount: highestAssessment.count,
                            })] })) })),
            },
        ]
        : []), true); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        assessmentUiInsights,
        t,
        openQuestionDetails,
        activeAssessment.assessmentClass.name,
        unassignedStudents,
        reopenAssessmentStudents,
        lowestAssessment,
        highestAssessment,
    ]);
    var createStandardsInsightsUI = function (standards) {
        var standardData = standards.areAllStandardsScoreEqual
            ? [
                {
                    insightKey: 'areAllStandardsScoreEqual',
                    iconName: 'bell-o',
                    children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dataInsight.standard.equallyScored') }),
                },
            ]
            : standards.highestPerformingStandards.length === 0
                ? [
                    {
                        iconName: 'bell-o',
                        insightKey: 'noStandardsData',
                        children: ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: activeAssessment.assessmentTemplate.isDiagnostic
                                ? t('dataInsight.standard.noStandardsEquip')
                                : t('dataInsight.standard.noStandardsExist') })),
                    },
                ]
                : [
                    {
                        iconName: 'double-up',
                        insightKey: 'highestPerformingStandards',
                        children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [standards.highestPerformingStandards.length > 1
                                    ? t('dataInsight.standard.highestPerformedStandards')
                                    : t('dataInsight.standard.highestPerformedStandard'), standards.highestPerformingStandards.map(function (standard, standardIndex) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "link", onClick: function () {
                                                return openStandardsModal([standard], standardToItemExternalIdMap.get(standard));
                                            }, children: standard }, standard), standardIndex !== standards.highestPerformingStandards.length - 1
                                            ? ', '
                                            : ''] })); })] })),
                    },
                    {
                        iconName: 'double-down',
                        insightKey: 'lowestPerformingStandards',
                        children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [standards.lowestPerformingStandards.length > 1
                                    ? t('dataInsight.standard.lowestPerformedStandards')
                                    : t('dataInsight.standard.lowestPerformedStandard'), standards.lowestPerformingStandards.map(function (standard, standardIndex) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "link", onClick: function () {
                                                return openStandardsModal([standard], standardToItemExternalIdMap.get(standard));
                                            }, children: standard }, standard), standardIndex !== standards.lowestPerformingStandards.length - 1 ? ', ' : ''] })); })] })),
                    },
                    {
                        iconName: 'double-down',
                        insightKey: 'standardsPerformingBelowClassAverage',
                        children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: "link", onClick: toggleStandardsWithScoreModal, children: standards.standardsPerformingBelowClassAverage > 1
                                        ? t('dataInsight.standard.belowClassAverageStandardsCount', {
                                            count: standards.standardsPerformingBelowClassAverage,
                                        })
                                        : t('dataInsight.standard.belowClassAverageStandardCount', {
                                            count: standards.standardsPerformingBelowClassAverage,
                                        }) }), standards.standardsPerformingBelowClassAverage > 1
                                    ? " ".concat(t('dataInsight.standard.belowClassAverageStandardsCountMessage'))
                                    : " ".concat(t('dataInsight.standard.belowClassAverageStandardCountMessage'))] })),
                    },
                ];
        setStandardUiInsights(standardData);
    };
    // handle Expand
    var handleExpansion = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // set first tab details
            setElementId(tableHeader[0].id);
            isDataLoaded ? '' : fetchDataInsights();
            setDataLoaded(true);
            return [2 /*return*/];
        });
    }); };
    // fetch list of student who got the max and min score for a particular assessment
    var fetchStudentsGotMaxOrMinScore = (0, react_1.useCallback)(function () {
        var maxScoreStudentsList = [];
        var minScoreStudentList = [];
        if (formattedData) {
            for (var i = 1; i < formattedData.length; i++) {
                var _a = formattedData[i], overall = _a.overall, id = _a.id;
                var maxScore = overall.maxScore, score = overall.score;
                if (maxScore === score) {
                    maxScoreStudentsList.push(students.get(id));
                }
                else if (score === 0) {
                    minScoreStudentList.push(students.get(id));
                }
            }
        }
        var maxStudentsList = sortStudentsListData(maxScoreStudentsList);
        var minStudentsList = sortStudentsListData(minScoreStudentList);
        var studentsDataInsightInfo = {
            maxStudentsList: maxStudentsList,
            minStudentsList: minStudentsList,
        };
        setMaxScoreStudents(maxStudentsList);
        setMinScoreStudents(minStudentsList);
        return studentsDataInsightInfo;
    }, [formattedData, students]);
    var fetchStudentsDataInsights = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var maxorminScoreStudentData, assessmentClass, assessmentTemplate, bands, bandsDistribution, itemType, assigneesPerformanceData, classPerformanceData, skippedItemsData, highestSkippedQuestions, overallPercentage_1, criteria, studentsPerformance;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    maxorminScoreStudentData = fetchStudentsGotMaxOrMinScore();
                    if (!activeAssessment) return [3 /*break*/, 8];
                    assessmentClass = activeAssessment.assessmentClass, assessmentTemplate = activeAssessment.assessmentTemplate;
                    return [4 /*yield*/, performanceBandService.findByCurriculum(assessmentTemplate.curriculum)];
                case 1:
                    bands = _b.sent();
                    return [4 /*yield*/, analyticsService.getAssessmentPerformanceBandDistributionByClassAndTemplate([assessmentClass], assessmentTemplate, bands)];
                case 2:
                    bandsDistribution = _b.sent();
                    itemType = activeAssessment.assessmentTemplate.isDiagnostic ? api_1.ItemType.Core : null;
                    assigneesPerformanceData = null;
                    classPerformanceData = null;
                    return [4 /*yield*/, analyticsService.getStudentsSkippedItemsPercentage(assessmentClass === null || assessmentClass === void 0 ? void 0 : assessmentClass.id, assessmentTemplate === null || assessmentTemplate === void 0 ? void 0 : assessmentTemplate.id)];
                case 3:
                    skippedItemsData = _b.sent();
                    highestSkippedQuestions = (_a = skippedItemsData === null || skippedItemsData === void 0 ? void 0 : skippedItemsData.items) === null || _a === void 0 ? void 0 : _a.sort((0, api_1.sortByCriteria)({
                        property: 'skipPercentage',
                        direction: api_1.SortDirectionEnumerables.descending,
                    })).filter(function (item, _, array) { return item.skipPercentage === array[0].skipPercentage; }).map(function (item) {
                        var _a;
                        var classPerformanceItem = classPerformance.itemsPerformance.find(function (performance) { return performance.item.externalId === item.itemId; });
                        // @ts-ignore
                        item.label = (_a = classPerformanceItem === null || classPerformanceItem === void 0 ? void 0 : classPerformanceItem.item) === null || _a === void 0 ? void 0 : _a.label;
                        return item;
                    }).sort((0, api_1.sortByCriteria)({
                        property: 'label',
                        direction: api_1.SortDirectionEnumerables.ascending,
                    }));
                    if (!activeAssessment.assessmentTemplate.isDiagnostic) return [3 /*break*/, 6];
                    return [4 /*yield*/, analyticsService.getAssigneesPerformancesByClassAndTemplate([assessmentClass], assessmentTemplate, bands, undefined, undefined, itemType, itemStandards)];
                case 4:
                    assigneesPerformanceData =
                        _b.sent();
                    return [4 /*yield*/, analyticsService.getClassPerformanceByClassAndTemplate([assessmentClass], assessmentTemplate, assigneesPerformanceData, bands, itemType)];
                case 5:
                    classPerformanceData = _b.sent();
                    return [3 /*break*/, 7];
                case 6:
                    classPerformanceData = classPerformance;
                    assigneesPerformanceData = assigneesPerformance;
                    _b.label = 7;
                case 7:
                    overallPercentage_1 = classPerformanceData.overallPercentage;
                    criteria = {
                        property: 'name',
                        direction: api_1.SortDirectionEnumerables.ascending,
                    };
                    studentsPerformance = assigneesPerformanceData
                        ? assigneesPerformanceData
                            .filter(function (assigneePerformance) { return assigneePerformance.overallPercentage < overallPercentage_1; })
                            .map(function (assigneePerformance) {
                            var assignee = assigneePerformance.assignee;
                            return {
                                id: assignee.id,
                                name: assignee.lastNameFirstName,
                                overallPercentage: assigneePerformance.overallPercentage,
                            };
                        })
                            .sort((0, api_1.sortByCriteria)(criteria))
                        : [];
                    return [2 /*return*/, {
                            maxorminScoreStudentData: maxorminScoreStudentData,
                            overallPercentage: overallPercentage_1,
                            studentsPerformance: studentsPerformance,
                            isAllStudentsPerformingEqually: (assigneesPerformanceData === null || assigneesPerformanceData === void 0 ? void 0 : assigneesPerformanceData.length) > 0 && (studentsPerformance === null || studentsPerformance === void 0 ? void 0 : studentsPerformance.length) === 0,
                            bandsDistribution: bandsDistribution,
                            highestSkippedQuestions: highestSkippedQuestions,
                        }];
                case 8: return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        activeAssessment,
        analyticsService,
        itemStandards,
        performanceBandService,
        assigneesPerformance,
        classPerformance,
    ]);
    var fetchUnAssignedStudents = (0, react_1.useCallback)(function () {
        return assigneeUsageService
            .findUnassignedByContextAndTemplate(activeAssessment.assessmentTemplate.id, activeAssessment.assessmentClass.id)
            .then(function (studentIds) {
            var studentsList = studentIds
                .map(function (id) { return students.get(id); })
                .sort(function (student1, student2) {
                return student1.lastNameFirstName.localeCompare(student2.lastNameFirstName);
            });
            setUnassignedStudents(studentsList);
        })
            .catch(function () {
            return toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.standardsData'),
                },
            });
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, activeAssessment, assigneeUsageService, students]);
    var fetchHighestAndLowestAssessments = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var assessmentClass, assessmentTemplate, assessmentsInfoData, _a, highestPerformance, lowestPerformance, lowestAssessment_1, highestAssessment_1, highestPerformanceMap, lowestPerformanceMap, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    assessmentClass = activeAssessment.assessmentClass, assessmentTemplate = activeAssessment.assessmentTemplate;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, analyticsService.getLowestAndHighestPerformingAssessment(assessmentClass.id)];
                case 2:
                    assessmentsInfoData = _c.sent();
                    _a = assessmentsInfoData[0], highestPerformance = _a.highestPerformance, lowestPerformance = _a.lowestPerformance;
                    // If there is only one assessment exist for a class than that assessment come under both highest and lowest
                    // In that case we won't show the highlight in the data Insight
                    if (highestPerformance.length === 1 &&
                        lowestPerformance.length === 1 &&
                        highestPerformance[0].id === lowestPerformance[0].id) {
                        lowestAssessment_1 = {
                            exist: false,
                        };
                        highestAssessment_1 = {
                            exist: false,
                        };
                    }
                    else {
                        highestPerformanceMap = getPerformanceInfoOfAssessments(highestPerformance);
                        lowestPerformanceMap = getPerformanceInfoOfAssessments(lowestPerformance);
                        lowestAssessment_1 = {
                            exist: lowestPerformanceMap.has(assessmentTemplate.id),
                            count: lowestPerformance.length - 1,
                        };
                        highestAssessment_1 = {
                            exist: highestPerformanceMap.has(assessmentTemplate.id),
                            count: highestPerformance.length - 1,
                        };
                    }
                    setLowestAssessment(lowestAssessment_1);
                    setHighestAssessment(highestAssessment_1);
                    return [3 /*break*/, 4];
                case 3:
                    _b = _c.sent();
                    return [2 /*return*/, toast({
                            alertVariant: 'error',
                            content: {
                                title: t('errorMessages.oopsErr'),
                                message: t('errorMessages.assessmentList'),
                            },
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, activeAssessment, analyticsService]);
    var fetchReopenAssessmentsCount = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var assessmentClass, assessmentTemplate, studentsData, studentsIdCount_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    assessmentClass = activeAssessment.assessmentClass, assessmentTemplate = activeAssessment.assessmentTemplate;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, summaryService.getReopenAssessmentByClassAndTemplate(assessmentClass.id, assessmentTemplate.id)];
                case 2:
                    studentsData = _b.sent();
                    studentsIdCount_1 = [];
                    studentsData.forEach(function (_a) {
                        var assigneeId = _a.assigneeId, assessmentAssignedCount = _a.assessmentAssignedCount, reopenCount = _a.reopenCount;
                        if (reopenCount > 0) {
                            var student = new StudentDetailsAndReopenCount(__assign({}, students.get(assigneeId)));
                            student.reopenCount = reopenCount;
                            student.assessmentAssignedCount = assessmentAssignedCount;
                            studentsIdCount_1.push(student);
                        }
                    });
                    setReopenAssessmentStudents(studentsIdCount_1.sort(function (student1, student2) {
                        return student1.lastNameFirstName.localeCompare(student2.lastNameFirstName);
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, toast({
                            alertVariant: 'error',
                            content: {
                                title: t('errorMessages.oopsErr'),
                                message: t('errorMessages.standardsData'),
                            },
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, summaryService, activeAssessment, students]);
    var fetchAssessmentsDataInsights = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var coreItemsPerformance, itemPerformanceMap_1, itemPercentageArray, minValue_2, maxValue_2, areAllItemsPerformanceEqual, highestPerformingItems_1, lowestPerformingItems_1, assessmentsInsightInfo;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = classPerformance === null || classPerformance === void 0 ? void 0 : classPerformance.itemsPerformance) === null || _a === void 0 ? void 0 : _a.length)) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchUnAssignedStudents()];
                case 1:
                    _b.sent(); // its part of assessments hence added a call here
                    return [4 /*yield*/, fetchReopenAssessmentsCount()];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, fetchHighestAndLowestAssessments()];
                case 3:
                    _b.sent();
                    coreItemsPerformance = classPerformance.itemsPerformance.filter(function (item) { return item.item.type === api_1.ItemType.Core && item.maxScore > 0; });
                    itemPerformanceMap_1 = new Map(coreItemsPerformance.map(function (itemPerformance) { return [itemPerformance.item.label, 0]; }));
                    // setting the value of each question number with its corresponding percentage
                    if (itemPerformanceMap_1.size) {
                        coreItemsPerformance.forEach(function (itemPerformance) {
                            itemPerformanceMap_1.set(itemPerformance.item.label, itemPerformance.percentage);
                        });
                    }
                    itemPercentageArray = Array.from(itemPerformanceMap_1.values());
                    minValue_2 = 100;
                    maxValue_2 = 0;
                    itemPercentageArray.forEach(function (value) {
                        if (value > maxValue_2) {
                            maxValue_2 = Math.round(value);
                        }
                        if (value < minValue_2) {
                            minValue_2 = Math.round(value);
                        }
                    });
                    areAllItemsPerformanceEqual = minValue_2 === maxValue_2;
                    highestPerformingItems_1 = [];
                    lowestPerformingItems_1 = [];
                    assessmentsInsightInfo = {
                        highestPerformingItems: highestPerformingItems_1,
                        lowestPerformingItems: lowestPerformingItems_1,
                        areAllItemsPerformanceEqual: areAllItemsPerformanceEqual,
                    };
                    if (!areAllItemsPerformanceEqual) {
                        coreItemsPerformance.forEach(function (itemPerformance) {
                            var itemPerformanceRoundedValue = Math.round(itemPerformanceMap_1.get(itemPerformance.item.label));
                            if (itemPerformanceRoundedValue === maxValue_2) {
                                highestPerformingItems_1.push(itemPerformance.item.label);
                            }
                            if (itemPerformanceRoundedValue === minValue_2) {
                                lowestPerformingItems_1.push(itemPerformance.item.label);
                            }
                        });
                    }
                    return [2 /*return*/, assessmentsInsightInfo];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [
        classPerformance,
        fetchUnAssignedStudents,
        fetchReopenAssessmentsCount,
        fetchHighestAndLowestAssessments,
    ]);
    var fetchDataInsights = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, studentInSights, _c, standardInSights, assessmentInsights;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setIsLoadingDataInsights(true);
                    return [4 /*yield*/, Promise.all([
                            fetchStudentsDataInsights(),
                            fetchStandardsDataInsights(),
                            fetchAssessmentsDataInsights(),
                        ])];
                case 1:
                    _a = _d.sent(), _b = _a[0], studentInSights = _b === void 0 ? defaultStudentsInsights : _b, _c = _a[1], standardInSights = _c === void 0 ? defaultStandardInsights : _c, assessmentInsights = _a[2];
                    setStudentsInsight(studentInSights);
                    createStudentInsightsUI(studentInSights);
                    createStandardsInsightsUI(standardInSights);
                    setAssessmentUiInsights(assessmentInsights);
                    setIsLoadingDataInsights(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var allDataInsights = (0, react_1.useMemo)(function () {
        var allInsights = [];
        studentUiInsights.map(function (insight) {
            if (allInsightsKeys.includes(insight.insightKey)) {
                allInsights.push(insight);
            }
            return insight;
        });
        standardUiInsights.map(function (insight) {
            if (allInsightsKeys.includes(insight.insightKey)) {
                allInsights.push(insight);
            }
            return insight;
        });
        createAssessmentInsightsUI.forEach(function (insight) {
            if (allInsightsKeys.includes(insight.insightKey)) {
                allInsights.push(insight);
            }
        });
        return allInsights;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [standardUiInsights, createAssessmentInsightsUI, assessmentUiInsights, studentUiInsights]);
    // Render data for insights for different tab
    var renderInsight = (0, react_1.useCallback)(function (tabId) {
        switch (tabId) {
            case 'students': {
                return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: studentUiInsights.map(function (_a, index) {
                        var iconName = _a.iconName, children = _a.children, insightKey = _a.insightKey;
                        return ((0, jsx_runtime_1.jsx)("div", { className: "row-data", children: rowContainer({ iconName: iconName, children: children }) }, "row-data-".concat(index, "-").concat(insightKey)));
                    }) }));
            }
            case 'standard': {
                return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: standardUiInsights.map(function (_a, index) {
                        var iconName = _a.iconName, children = _a.children, insightKey = _a.insightKey;
                        return ((0, jsx_runtime_1.jsx)("div", { className: "row-data", children: rowContainer({ iconName: iconName, children: children }) }, "row-data-".concat(index, "-").concat(insightKey)));
                    }) }));
            }
            case 'assessment': {
                return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: createAssessmentInsightsUI.map(function (_a, index) {
                        var iconName = _a.iconName, children = _a.children, insightKey = _a.insightKey;
                        return ((0, jsx_runtime_1.jsx)("div", { className: "row-data", children: rowContainer({ iconName: iconName, children: children }) }, "row-data-".concat(index, "-").concat(insightKey)));
                    }) }));
            }
            default: {
                return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: allDataInsights.map(function (_a, index) {
                        var iconName = _a.iconName, children = _a.children, insightKey = _a.insightKey;
                        return ((0, jsx_runtime_1.jsx)("div", { className: "row-data", children: rowContainer({ iconName: iconName, children: children }) }, "row-data-".concat(index, "-").concat(insightKey)));
                    }) }));
            }
        }
    }, [studentUiInsights, standardUiInsights, createAssessmentInsightsUI, allDataInsights]);
    var insightDataContent = (0, react_1.useMemo)(function () { return renderInsight(elementId); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [elementId, isLoadingDataInsights, renderInsight]);
    // header details data
    var renderCollapseHeaderContent = function () { return ((0, jsx_runtime_1.jsxs)(DpDataInsight_styled_1.StyledDataInsightHeader, { className: "content-header", children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { name: "light-bulb" }), (0, jsx_runtime_1.jsxs)("div", { className: "subTitle", children: [(0, jsx_runtime_1.jsx)("h2", { children: t('dataInsight.title') }), (0, jsx_runtime_1.jsx)("span", { children: t('dataInsight.subTitle') })] })] })); };
    // we need to maintained a body component for body part
    // should be change the value of ariaLabel
    var renderCollapseBodyContent = function () {
        var navigationTabs = tableHeader.map(function (_a, index) {
            var id = _a.id, label = _a.label;
            return ({
                active: !!id,
                ariaLabel: t('dataInsight.ariaLabels.headers', {
                    tab: label,
                }),
                id: id,
                label: label,
            });
        });
        var selectTab = function (element) {
            setElementId(element.id);
        };
        return ((0, jsx_runtime_1.jsxs)(DpDataInsight_styled_1.StyledDataInsightBody, { className: "content-body", children: [isLoadingDataInsights ? ((0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { className: "data-insight-spinner" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(DpNavigationTabs_1.default, { elements: navigationTabs, selectionHandler: selectTab }), (0, jsx_runtime_1.jsx)("div", { className: "data-container", children: insightDataContent })] })), unassignedStudents.length ? ((0, jsx_runtime_1.jsx)(StudentsDataModal, { studentsDetails: unassignedStudents, show: showUnAssignedStudents, onHide: toggleUnAssignedStudentsModal, title: t('dataInsight.assessmentTemplates.unAssigned.studentsModalTitle'), listTitle: t('dataInsight.assessmentTemplates.studentName') })) : null, standardsInfoBelowClassAverage.length ? ((0, jsx_runtime_1.jsx)(StandardPerformancesDetailsBelowClassAverageModal, { standardsWithPercentage: standardsInfoBelowClassAverage, show: showStandardsWithScoreModal, onHide: toggleStandardsWithScoreModal, title: t('dataInsight.standard.standardsModalTitle'), standardTitle: "Standard", scoreTitle: "Score" })) : null, reopenAssessmentStudents.length ? ((0, jsx_runtime_1.jsx)(ReOpenAssessmentStudentsModal, { title: t('dataInsight.assessmentTemplates.reOpened.modalTitle'), show: showReopenAssessmentStudents, onHide: toggleReOpenAssessmentsStudentsModal, studentsDetails: reopenAssessmentStudents })) : null, maxScoreStudents.length ? ((0, jsx_runtime_1.jsx)(StudentsDataModal, { studentsDetails: maxScoreStudents, title: t('dataInsight.studentTemplates.studentsMaxScoreModalTitle'), listTitle: t('dataInsight.assessmentTemplates.studentName'), show: showMaxScoreStudentsModal, onHide: toggleMaxScoreStudentsModal })) : null, minScoreStudents.length ? ((0, jsx_runtime_1.jsx)(StudentsDataModal, { studentsDetails: minScoreStudents, title: t('dataInsight.studentTemplates.studentsMinScoreModalTitle'), listTitle: t('dataInsight.assessmentTemplates.studentName'), show: showMinScoreStudentsModal, onHide: toggleMinScoreStudentsModal })) : null, studentsInsight.studentsPerformance && ((0, jsx_runtime_1.jsx)(BelowPerformingStudentsModal, { show: showBelowPerformingStudentsModal, closeHandler: toggleBelowPerformingStudentsModal, performanceData: studentsInsight }))] }));
    };
    return ((0, jsx_runtime_1.jsx)(DpDataInsight_styled_1.StyledDpDataInsight, { children: (0, jsx_runtime_1.jsx)(DpCollapse_1.default, { headerContent: renderCollapseHeaderContent(), expanded: false, icon: "chevron", onExpansion: handleExpansion, identifier: "data_insights", iconAriaLabel: t('dataInsight.ariaLabel.collapseButton'), children: renderCollapseBodyContent() }) }));
};
exports.DpDataInsight = DpDataInsight;
exports.default = exports.DpDataInsight;
